import { render, staticRenderFns } from "./NavigationTop.vue?vue&type=template&id=5079b398&scoped=true&"
import script from "./NavigationTop.vue?vue&type=script&lang=js&"
export * from "./NavigationTop.vue?vue&type=script&lang=js&"
import style0 from "./NavigationTop.vue?vue&type=style&index=0&id=5079b398&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5079b398",
  null
  
)

export default component.exports